export const searchAdminItems = `
id
sk 
name 
idInc 
createdAt 
updatedAt 
resource {
  id
  sk
  name
}
workspaceId
`;

export const searchAdminExams = `
id
sk 
name 
idInc 
createdAt 
updatedAt
scoreMax
scoreActual
resource {
  id
  sk
  name
}
workspaceId
`;
